'use strict';

angular.module('docketbook').
  controller('selectOrderController', function (orderService, $rootScope, $scope, $state, $stateParams, Restangular, accessControl, $timeout, $q) {

    // Initialise variables to be used
    $scope.orderSearch = "";
    $scope.orderSearchLoading = false;
    $scope.orderSearchList = [];
    $scope.orderSearchListFull = [];
    $scope.orderSelectCallback = null;
    $scope.listCount = 0;
    $scope.desktopSelected = [];

    $scope.query = {
      limit: 10,
      page: 1,
      order: 'orderNumber'
    };

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.orderSelectFromParent = function (options, cb) {
      $scope.orderSearch = "";
      $scope.orderSearchLoading = false;
      $scope.orderSearchList = [];
      $scope.orderSearchOptions = options;
      if (options) {
        $scope.orderExisting = options.currentOrder;
      } else {
        $scope.orderExisting = null;
      }
      $scope.orderSelectCallback = cb;
      $scope.desktopSelected = [];
      if ($stateParams.device == 'desktop') {
        $("#selectOrderModal").fadeIn(100);
        $("input[name='selectOrderInput']").focus();
      }
      $scope.loadOrderList();
    }

    $scope.loadOrderList = function () {
      $scope.orderSearchLoading = true;
      var options = {};
      if ($scope.orderSearchOptions) {
        options = $scope.orderSearchOptions;
      }
      var searchValue = options.searchValue;
      $scope.promise = $q(function (resolve, reject) {
        var queryParams = {};
        if ($stateParams.device == 'desktop') {
          queryParams.limit = $scope.query.limit;
          queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
          queryParams.sort = $scope.query.order;
        } else {
          queryParams.sort = 'orderNumber';
        }
        if (options && options.statusList) {
          queryParams.statusList = options.statusList;
        }
        if (options && options.hasCustomer) {
          queryParams.hasCustomer = options.hasCustomer;
        }
        if (options && options.supplier) {
          queryParams.supplier = options.supplier.join(',');
        }
        if (options && options.customer) {
          queryParams.customer = options.customer.join(',');
        }
        if (searchValue != null && searchValue != "") {
          queryParams.orderNumber = searchValue;
        }
        orderService.getOrders(queryParams, function (returnObject) {
          var ordersInList = {};
          $scope.orderSearchList = returnObject;
          if (queryParams.offset <= 0 && returnObject.length < queryParams.limit) {
            $scope.listCount = returnObject.length;
          } else {
            $scope.listCount = queryParams.offset + (queryParams.limit + 1);
          }
          for (var i = 0; i < $scope.orderSearchList.length; i++) {
            $scope.orderSearchList[i].statusDisplay = $scope.orderSearchList[i].status.charAt(0).toUpperCase() + $scope.orderSearchList[i].status.slice(1);
            if ($scope.orderExisting && ($scope.orderSearchList[i].id == $scope.orderExisting.id)) {
              $scope.orderSearchList[i].existing = true;
            }
            if ($scope.orderSearchOptions.hasOrderNumber && $scope.orderSearchList[i].orderNumber == null) {
              $scope.orderSearchList[i].existing = true;
            }
            ordersInList[$scope.orderSearchList[i].id] = true;
          }
          for (var i = 0; i < $scope.orderSearchList.length; i++) {
            if ($scope.orderSearchList[i].supplierRefNo && $scope.orderSearchList[i].supplierRefNo.indexOf('xq') != -1) {
              var splits = $scope.orderSearchList[i].supplierRefNo.split('_');
              var xeroQuoteNumber = splits[1];
              if (xeroQuoteNumber) {
                $scope.orderSearchList[i].supplierXeroQuoteNumber = xeroQuoteNumber;
              }
            }
            if ($scope.orderSearchList[i].customerRefNo && $scope.orderSearchList[i].customerRefNo.indexOf('xq') != -1) {
              var splits = $scope.orderSearchList[i].customerRefNo.split('_');
              var xeroQuoteNumber = splits[1];
              if (xeroQuoteNumber) {
                $scope.orderSearchList[i].customerXeroQuoteNumber = xeroQuoteNumber;
              }
            }
          }
          // also do a getOrders based on searchValue being a customerRefNo
          if (searchValue != null && searchValue != "") {
            delete queryParams.orderNumber;
            queryParams.customerRefNo = searchValue;
            orderService.getOrders(queryParams, function (returnObject) {
              for (var i = 0; i < returnObject.length; i++) {
                if (ordersInList[returnObject[i]] != true) {
                  returnObject[i].statusDisplay = returnObject[i].status.charAt(0).toUpperCase() + returnObject[i].status.slice(1);
                  if ($scope.orderExisting && (returnObject[i].id == $scope.orderExisting.id)) {
                    returnObject[i].existing = true;
                  }
                  if ($scope.orderSearchOptions.hasOrderNumber && returnObject[i].orderNumber == null) {
                    returnObject[i].existing = true;
                  }
                  ordersInList[returnObject[i].id] = true;
                  $scope.orderSearchList.push(returnObject[i]);
                }
              }
              delete queryParams.customerRefNo;
              queryParams.supplierRefNo = searchValue;
              orderService.getOrders(queryParams, function (returnObject) {
                for (var i = 0; i < returnObject.length; i++) {
                  if (ordersInList[returnObject[i]] != true) {
                    returnObject[i].statusDisplay = returnObject[i].status.charAt(0).toUpperCase() + returnObject[i].status.slice(1);
                    if ($scope.orderExisting && (returnObject[i].id == $scope.orderExisting.id)) {
                      returnObject[i].existing = true;
                    }
                    if ($scope.orderSearchOptions.hasOrderNumber && returnObject[i].orderNumber == null) {
                      returnObject[i].existing = true;
                    }
                    ordersInList[returnObject[i].id] = true;
                    $scope.orderSearchList.push(returnObject[i]);
                  }
                }
                for (var i = 0; i < $scope.orderSearchList.length; i++) {
                  if ($scope.orderSearchList[i].supplierRefNo && $scope.orderSearchList[i].supplierRefNo.indexOf('xq') != -1) {
                    var splits = $scope.orderSearchList[i].supplierRefNo.split('_');
                    var xeroQuoteNumber = splits[1];
                    if (xeroQuoteNumber) {
                      $scope.orderSearchList[i].supplierXeroQuoteNumber = xeroQuoteNumber;
                    }
                  }
                  if ($scope.orderSearchList[i].customerRefNo && $scope.orderSearchList[i].customerRefNo.indexOf('xq') != -1) {
                    var splits = $scope.orderSearchList[i].customerRefNo.split('_');
                    var xeroQuoteNumber = splits[1];
                    if (xeroQuoteNumber) {
                      $scope.orderSearchList[i].customerXeroQuoteNumber = xeroQuoteNumber;
                    }
                  }
                }
                $scope.orderSearchLoading = false;
                resolve('Done');
              });
            });
          } else {
            $scope.orderSearchLoading = false;
            resolve('Done');
          }
        }, function (err) {
          $scope.orderSearchLoading = false;
          $scope.orderLoadingError = "Error getting orders";
          $scope.orderSearchList = [];
          reject('Error');
        });
      });
    }

    $scope.assignOrderToDocket = function (order) {
      $scope.orderSelectCallback(order);
    }

    $scope.closeOrderSelectList = function () {
      $scope.orderSelectCallback(null);
      if ($stateParams.device == 'desktop') {
        $("#selectOrderModal").fadeOut(100);
      }
    }

    $scope.desktopSelectOrderContinue = function () {
      var selected = $scope.desktopSelected[0];
      $scope.orderSelectCallback(selected);
      $("#selectOrderModal").fadeOut(100);
    }

    /********************************/
    /***** Search Functionality *****/
    /********************************/

    $scope.searchOrderChange = function (searchValue) {
      if ($scope.orderSearchOptions) {
        var options = angular.copy($scope.orderSearchOptions);
        $scope.orderSearchOptions.searchValue = searchValue;
        options.searchValue = searchValue;
        $scope.loadOrderList(null, options);
      } else {
        $scope.loadOrderList(null);
      }
    }

    $scope.updateOrderSearch = function (searchValue) {
      $scope.orderSearchLoading = true;
      $scope.orderSearch = searchValue;
      $scope.loadOrderList();
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/selectors/selectOrderController.js